<template>
  <div class="figureBarHorizontal">
    <div class="chart">
      <ul class="chart__scale">
        <li class="item"><span class="item__num">0</span></li>
        <li class="item"><span class="item__num">10</span></li>
        <li class="item"><span class="item__num">20</span></li>
        <li class="item"><span class="item__num">30</span></li>
        <li class="item"><span class="item__num">40</span></li>
        <li class="item"><span class="item__num">50</span></li>
        <li class="item"><span class="item__num">60</span></li>
        <li class="item"><span class="item__num">70</span></li>
        <li class="item"><span class="item__num">80</span></li>
        <li class="item"><span class="item__num">90</span></li>
        <li class="item"><span class="item__num"><span class="unit unit--percent">100</span></span></li>
      </ul>
      <ul class="chart__bar">
        <li class="item item--addBar item--star" v-if="!isReview">
          <span class="item__fill" ref="rateCountBarStar" style="width: 0%;"></span>
        </li>
        <li class="item item--addBar">
          <div class="item__fill" ref="rateCountBar" style="width: 0%;">
            <span class="num num--outsize" ref="rateCount" :style="{animationDelay: `calc(0.014s*${getPercent})`}">0</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
  
<script setup lang="ts">
  import {watch, ref, computed} from "vue";
  
  const props = withDefaults(
    defineProps<{
      percentage?: number | null;
      isActive?: boolean;
      isReview?: boolean;
    }>(),
    {
      percentage: null,
      isActive: true,
      isReview: false,
    }
  );

  const emit = defineEmits<{
    (e: 'update-percentage', id: any): void,
  }>()
  const rateCountBarStar = ref(null)
  const rateCountBar = ref(null)
  const rateCount = ref(null)

  const getPercent = computed(() => {
    return props.percentage === null ? 0 : props.percentage as number;
  })
  
  function animate() {
    return new Promise((resolve, reject) => {
      let _speed = 15;
      let _rateCountNum = parseInt(rateCount.value.textContent);
      let _rateCountData = getPercent.value
      let _rateTgt = _rateCountData;
      rateCount.value.innerText = _rateCountData;

      let id = setInterval(function () {
        if(rateCountBar.value && _rateCountNum <= _rateTgt){
          rateCountBar.value.style.width = _rateCountNum + '%';
          if(rateCountBarStar.value){
            rateCountBarStar.value.style.width = _rateCountNum + '%';
          }
          _rateCountNum++;
        } else {
          clearInterval(id)
          emit('update-percentage', _rateCountNum)
          resolve(true)
        }
      }, _speed);
    })
  }
  watch(
    () => props.isActive,
    (newVal) => {
      if(newVal){
        animate()
      }
    }
  )
</script>
  